@if (this.currentFicheConseil?.natureOperation?.id === 1) {
  <div *ngIf="currentFicheConseil?.natureOperation?.id === 1" class="flex-vertical gap-32">
    <div class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-48 card">
      <div class="flex-vertical gap-8">
        <h6>Sélection du produit</h6>
      </div>
      <div class="oui-form-line">
        <oui-autocomplete
          *ngIf="produitControl; else loading"
          class="oui-form-field-lg"
          [control]="produitControl"
          [options]="produitOptions"
          [errors]="produitErrors"
          [displayOptionsOnEmptySearch]="true"
          [displayResetButton]="true"
          label="Produit"
          #produitField>
        </oui-autocomplete>
      </div>
      <ng-template #loading>
        <div class="flex-horizontal width-100pc flex-center justify-center">
          <oui-loading></oui-loading>
        </div>
      </ng-template>
    </div>
    <ng-container *ngIf="!isUpdatingProduit; else updating">
      <app-versement *ngIf="produitControl.value" [shouldResetFraisVersement]="produitChanged"></app-versement>
      <app-mode-de-gestion
        *ngIf="formConfigService.getSelectedProduit()?.gestionPossibles?.length"></app-mode-de-gestion>
      <app-allocation-asset
        *ngIf="
          formConfigService.getSelectedProduit()?.gestionPossibles?.length && currentFicheConseil?.modeDeGestion?.code
        "></app-allocation-asset>
    </ng-container>
    <ng-template #updating>
      <div class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-48 card">
        <div class="flex-horizontal width-100pc flex-center justify-center">
          <oui-loading></oui-loading>
        </div>
      </div>
    </ng-template>
  </div>
} @else {
  <div class="flex-vertical gap-32">
    <app-motivation-operation
      *ngIf="uiPolicy.showMotivationOperationBlock"
      [control]="motivationOperationControl"
      [options]="motivationOperationOptions"
      [errors]="motivationOperationErrors"></app-motivation-operation>

    <div
      *ngIf="uiPolicy.showOperationsAnnexes"
      class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-48 card">
      <h6>Opérations annexes</h6>
      <div class="flex-vertical gap-8">
        <div class="body-2">En plus de l’opération principale souhaitez vous ajouter :</div>
        <oui-checkbox
          label="Mise en place ou modification de versements programmés"
          [control]="avecMiseEnPlaceOuModificationVP"></oui-checkbox>
        <oui-checkbox label="Arbitrages programmés" [control]="avecArbitragesProgrammes"></oui-checkbox>
      </div>
    </div>
    <app-versement
      *ngIf="uiPolicy.showVersementBlock"
      (changementAllocationChange)="onChangementAllocationReceived($event)"
      (vpModeChange)="onVpModeChange($event)"
      [avecMiseEnPlaceOuModificationVP]="avecMiseEnPlaceOuModificationVP"></app-versement>
    <app-mode-de-gestion
      *ngIf="uiPolicy.showModeDeGestionBlock"
      [arbitrageVP]="avecArbitragesProgrammes"></app-mode-de-gestion>

    <app-allocation-asset
      [vpMode]="selectedVpMode ?? null"
      *ngIf="uiPolicy.showAllocationBlock && currentFicheConseil?.modeDeGestion?.code"
      [avecMiseEnPlaceOuModificationVP]="avecMiseEnPlaceOuModificationVP"
      [avecChangementAllocation]="changementAllocation"></app-allocation-asset>

    <div
      class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-48 card"
      *ngIf="uiPolicy.showStandaloneAllocationBlock && shouldShowFondsEvenementielsBlock">
      <div class="flex-vertical gap-16">
        <div class="subtitle-1">Fonds événementiels (Exceltis, autres)</div>
        <div class="flex-vertical gap-8">
          <div class="body-2">
            Si nécessaire, sélectionner la ou les gammes de fonds événementiels comprises dans l'allocation :
          </div>
          <app-fonds-evenementiel-checkbox
            *ngFor="let fonds of fondsEvenementielsWithOrder | orderBy : 'ordre' : []"
            [fonds]="fonds"></app-fonds-evenementiel-checkbox>
        </div>
      </div>
    </div>

    <app-allocation-asset
      [vpMode]="selectedVpMode ?? null"
      *ngIf="uiPolicy.showStandaloneAllocationBlock"
      [avecMiseEnPlaceOuModificationVP]="avecMiseEnPlaceOuModificationVP"
      [avecChangementAllocation]="changementAllocation"></app-allocation-asset>
  </div>
}
